// Ours
import { baseTheme } from './base';

// TODO: support custom theme
export default baseTheme;
